<template>
    <div id="right_service">
        <div class="service_box" v-if="servicedata.pc_mobile">
            <!--@mouseenter="menuenter()" @mouseleave="menuleave()"-->
            <div class="service_box_el" style="cursor:pointer;">
                <ul>
                    <li><i class="icon iconfont icon-dianhua"></i></li>
                   <li>{{servicedata.pc_mobile.val}}</li>
                </ul>
            </div>
            <div class="service_box_el to_bd" @mouseenter="pc_addressenter()" @mouseleave="pc_addressleave()" @click="to_bd()">
                <ul>
                    <li><i class="icon iconfont icon-dizhi1"></i></li>
                    <li>{{servicedata.pc_address.val}}</li>
                </ul>
            </div>
            <div v-if="top_show" class="service_box_el" @click="to_top">
                <ul>
                    <li><i class="icon iconfont icon-up"></i></li>
                    <li></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:["service_data"],
        name: "right_service",
        data () {
            return {
                servicedata: {},
                top_show:false
            }
        },
        methods:{
            menuenter(){
                var _this = this;
                _this.servicedata.pc_mobile.show = true;
            },
            menuleave(){
                var _this = this;
                _this.servicedata.pc_mobile.show = false;
            },
            pc_addressenter(){
                var _this = this;
                _this.servicedata.pc_address.show = true;
            },
            pc_addressleave(){
                var _this = this;
                _this.servicedata.pc_address.show = false;
            },
            handleScroll () {
                var _this = this;
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if(scrollTop > 1000){
                    _this.top_show = true;
                }else{
                    _this.top_show = false;
                }
                var scrollHeight = document.body.scrollHeight;
                if(scrollTop == scrollHeight){
                }
            },
            to_top(){
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            },
            to_bd(){
                window.open("http://api.map.baidu.com/direction?origin=latlng:|name:无极机车&destination=重庆市九龙坡区隆鑫工业园&mode=driving&region=重庆&output=html");
            }

        },
        beforeCreate: function(){

        },
        created: function(){

        },
        beforeMount:function(){

        },
        mounted: function(){
            window.addEventListener('scroll', this.handleScroll);
            this.servicedata = this.service_data;
        },
        beforeUpdate:function(){

        },
        updated:function(){

        },
        beforeDestroy:function(){

        },
        destroyed:function(){

        }
    }
</script>
<style scoped>
    .service_box{
        position: fixed;
        right: 0;
        top: 150px;
    }
    .service_box .service_box_el{
        margin-bottom: 10px;
        height: 60px;
    }
    .service_box .service_box_el ul{
        overflow: hidden;
    }
    .service_box .service_box_el ul li{
        float: left;
        height: 60px;
        line-height: 60px;
        color: #fff;
        background: rgba(0,0,0,0.5);
        position: relative;
    }
    .service_box .service_box_el ul li:first-child{
        width: 60px;
        text-align: center;

    }
    .service_box .service_box_el ul li:first-child i{
        font-size: 24px;
    }
    .service_box .service_box_el ul li:first-child{
        position: absolute;
        right: 0;
    }
    .service_box .service_box_el:hover ul li:first-child{
        position: relative;
        right: auto;
    }
    .service_box .service_box_el ul li:last-child{
        white-space:nowrap;
        max-width: 0px;
        font-size: 18px;
        padding: 0;
        overflow: hidden;
    }
    .service_box .service_box_el:hover ul li:last-child{
        white-space:nowrap;
        max-width: 500px;
        padding-right: 20px;
        transition: max-width 0.5s;
    }
    .service_box_el:nth-child(3){
        cursor: pointer;
    }
    .service_box_el:nth-child(3) ul li:last-child{
        display: none;
    }
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all 30s;
    }
    .slide-fade-leave-active {
        transition: all .80s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }
    .to_bd{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/right_service.vue